import { TOOLS_POPOVERS } from "./constants";

export const isDev =
  window.location.hostname.includes("dev.vidboard") ||
  window.location.hostname.includes("localhost");

export const secondsToTime = (in_seconds) => {
  // let time = '';
  in_seconds = parseFloat(in_seconds.toFixed(2));

  var hours = Math.floor(in_seconds / 3600);
  var minutes = Math.floor((in_seconds - hours * 3600) / 60);
  var seconds = in_seconds - hours * 3600 - minutes * 60;
  //seconds = Math.floor( seconds );
  seconds = in_seconds.toFixed(0);

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  // if (seconds < 10) {
  //   seconds = "0" + seconds;
  // }
  // time = minutes + ':' + seconds;

  return seconds;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const groupByCategory = (arr, categories) => {
  return arr.reduce((acc, current) => {
    // If the category doesn't exist in the accumulator, add it as an empty array
    if (current.category === null) current.category = "";
    else
      current.category = categories.find(
        (item) => item.id === current.category
      )?.name;

    current.category = capitalizeFirstLetter(current.category);
    if (!acc[current.category]) {
      acc[current.category] = [];
    }
    // Push the current item to the category's array in the accumulator
    acc[current.category].push(current);
    return acc;
  }, {});
};

export const getTileImage = (item) => {
  // video tiles
  if (item.slideSnapshots && item.slideSnapshots.length > 0)
    return item.slideSnapshots[0];
  if (
    item.thumbnail &&
    (item.thumbnail.toString().includes("vidboard.ai") ||
      item.thumbnail.toString().includes("vidboard-ai"))
  )
    return item.thumbnail;
  if (item.filePath)
    return item.filePath.includes("vidboard.ai") ||
      item.filePath.includes("vidboard-ai")
      ? item.filePath
      : process.env.REACT_APP_SERVER_API_URL + item.filePath;
  // template
  if (item.frame)
    return item.frame.includes("vidboard.ai") ||
      item.frame.includes("vidboard-ai")
      ? item.frame
      : process.env.REACT_APP_SERVER_API_URL + item.frame;
};

export const getTileTitle = (item) => {
  // video tiles
  if (item.projectName) return item.projectName;
  // template
  if (item.name) return item.name;
};

export const getPopoverByName = (name, trial, disabled, maxAvatar) => {
  const popover = TOOLS_POPOVERS(trial, disabled, false, maxAvatar);
  return popover.find((popovers) => popovers?.name === name);
};

export const hasDidAvatar = (slides) =>
  slides.find((slide) => {
    const obj = slide?.objects?.find((s) => {
      return s.type === "avatar" && s.url.includes("d-id");
    });

    return !!obj;
  });

export const wrapPexelsImages = (media) => {
  let tempArr = [];
  for (let i = 0; i < media.length; i++) {
    const currentItem = media[i];
    tempArr.push({
      urls: {
        thumb: currentItem.src.tiny,
        main: currentItem.src.large,
      },
    });
  }
  return tempArr;
};

export const wrapPixabayImages = (media) => {
  let tempArr = [];
  for (let i = 0; i < media.length; i++) {
    const currentItem = media[i];
    tempArr.push({
      urls: {
        thumb: currentItem.previewURL,
        main: currentItem.previewURL, // do not use other url as those urls have token.
      },
    });
  }
  return tempArr;
};

export const wrapDidAvatars = (apiData) => {
  return apiData.map((presenter) => ({
    ...presenter,
    // thumb: presenter.thumbnailUrl,
  }));
};

export const wrapCustomImages = (apiData) => {
  let tempArr = [];
  for (let i = 0; i < apiData.length; i++) {
    const currentItem = apiData[i];
    tempArr.push({
      ...currentItem,
      urls: {
        thumb: currentItem.image,
        main: currentItem.image,
      },
    });
  }
  return tempArr;
};

export const wrapPixabayVideos = (apiData) => {
  let tempArr = [];
  for (let i = 0; i < apiData.hits.length; i++) {
    const currentItem = apiData.hits[i];
    tempArr.push({
      video: currentItem.videos.small.url,
      image: currentItem.videos.small.thumbnail,
    });
  }
  return tempArr;
};

export const loadFont = async (fontName, fontUrl) => {
  const font = new FontFace(fontName, `url(${fontUrl})`);
  try {
    await font.load();
    document.fonts.add(font);
  } catch (error) {
    console.error(`Error loading font ${fontName}:`, error);
  }
};

export const getSlideSaveBody = (projectId) => {
  return {
    userId: 637,
    projectId: projectId,
    noOfSlides: 1,
    slideId: 0,
    free: false,
    slide: {
      layout: "w=1920xh=1080",
      avatar: {},
      background: null,
      duration: 5,
      transData: {
        avatarGender: "Male",
        usedText: "Test",
        text: "Test",
        voice: {
          wav: "/media/user_data/637/mcjvsg50p1s/mcjvsg50p1s_0.wav",
          mp3: "/media/user_data/637/mcjvsg50p1s/mcjvsg50p1s_0.mp3",
        },
        languageValue: "en-US",
        voiceValue: "en-US-GuyNeural",
        transcriptLang: "",
        srt: "",
        url: "",
        transText: "",
        accentOption: false,
        captionOption: false,
      },
      slideData: [],
      start: 0,
    },
  };
};

export const getGenerateBody = (projectId) => {
  return {
    userId: 637,
    projectId: projectId,
    slides: [
      {
        transData: {
          avatarGender: "Male",
          usedText: "Test",
          text: "Test",
          voice: {
            wav: "/media/user_data/637/mcjvsg50p1s/mcjvsg50p1s_0.wav",
            mp3: "/media/user_data/637/mcjvsg50p1s/mcjvsg50p1s_0.mp3",
          },
          languageValue: "en-US",
          voiceValue: "en-US-GuyNeural",
          transcriptLang: "",
          srt: "",
          url: "",
          transText: "",
          accentOption: false,
          captionOption: false,
        },
        duration: 5,
        background: null,
        avatar: {
          square: false,
          top: 10,
          left: 20,
          user_avatar: false,
          angle: 0,
          url: "https://www.vidboard.ai/media/avatars/26.jpg",
          visible: true,
          avatarCode: "26",
          opaciity: 1,
          width: 500,
          height: 500,
          scaleX: 0.6400000000000001,
          scaleY: 0.6400000000000001,
        },
        maxAnimDuration: 1,
        slideData: null,
      },
    ],
    layout: "w=1920xh=1080",
    bgmusic: null,
    cover: {
      is_cover: false,
    },
    free: false,
  };
};

export const clearCookie = () => {
  document.cookie = `sessionid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  return;
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let ca = document.cookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    debugger;
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 1) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
